import {
    getFiltersService,
    getPersonsElementStatusService,
    getTaskPersonsElementStatusService,
} from '../services/statusTableService';
import { getKnowledgeElementService } from '../services/traineeService';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// async thunk
export const getTaskListInitialData = createAsyncThunk(
    'taskList/getInitialData',
    async () => {
        const response = await getFiltersService();
        return response.data;
    }
);

export const getLimitedPersonsElementStatus = createAsyncThunk(
    'taskList/getLimitedPersonsElementStatus',
    async (persons) => {
        const response = await getPersonsElementStatusService(persons, { personal: true });
        return response.data;
    }
);

export const getPersonsElementStatus = createAsyncThunk(
    'taskList/getPersonsElementStatus',
    async () => {
        const response = await getTaskPersonsElementStatusService();
        return response.data;
    }
);

export const updatePersonElement = createAsyncThunk(
    'taskList/updatePersonElement',
    async ({ menteeId, elementId }) => {
        const response = await getKnowledgeElementService(menteeId, elementId);
        return response.data;
    }
);

const initialState = {
    categories: {},
    knowledgeAreas: {},
    knowledgeElements: {},
    organisationUnits: {},
    persons: {},
    roles: {},
    wildcardPersons: {},
    isLoading: false,
};

// slice
const taskListSlice = createSlice({
    name: 'taskList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTaskListInitialData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getTaskListInitialData.fulfilled, (state, action) => {
                state.categories = action.payload.categories;
                state.knowledgeAreas = action.payload.knowledgeAreas;
                state.knowledgeElements = action.payload.knowledgeElements;
                state.organisationUnits = action.payload.organisationUnits;
                state.persons = action.payload.persons;
                state.roles = action.payload.roles;
                state.wildcardPersons = action.payload.wildcardPersons;
                state.isLoading = false;
            })
            .addCase(getTaskListInitialData.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(getLimitedPersonsElementStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getLimitedPersonsElementStatus.fulfilled, (state, action) => {
                state.persons = addElementStatusToPersons(state.persons, action.payload);
                state.isLoading = false;
            })
            .addCase(getLimitedPersonsElementStatus.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(getPersonsElementStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPersonsElementStatus.fulfilled, (state, action) => {
                state.persons = addElementStatusToPersons(state.persons, action.payload);
                state.isLoading = false;
            })
            .addCase(getPersonsElementStatus.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(updatePersonElement.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePersonElement.fulfilled, (state, action) => {
                state.persons = addPersonsToState(state.persons, action.payload);
                state.isLoading = false;
            })
            .addCase(updatePersonElement.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export default taskListSlice.reducer;
export const {
    taskListPersonsReceived,
    taskListKnowledgeElementsReceived,
    taskListknowledgeAreasReceived,
    taskListRolesReceived,
    taskListOrganisationUnitsReceived,
    taskListCategoriesReceived,
    taskListWildcardPersonsReceived,
    taskListPersonsElementStatusReceived,
    taskListPersonElementStatusReceived,
} = taskListSlice.actions;

//helpers
const addPersonsToState = (statePersons, personsToAdd) =>
    Object.keys(personsToAdd).reduce((acc, id) => {
        if (statePersons[id]) {
            return {
                ...acc,
                [id]: {
                    ...statePersons[id],
                    ...personsToAdd[id],
                },
            };
        }
        return {
            ...acc,
            [id]: personsToAdd[id],
        };
    }, {});

const addElementStatusToPersons = (statePersons, personsWithElementStatus) =>
    Object.keys(statePersons).reduce((acc, id) => {
        acc[id] = {
            ...statePersons[id],
            ...personsWithElementStatus[id],
        };
        return acc;
    }, {});